import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CatalogState } from '~app/modules/catalog/store';
import { select, Store } from '@ngrx/store';
import { Category } from '~app/modules/generic/models';
import { CommonProps } from '~app/modules/catalog/models';
import { getCategory } from '~app/modules/generic/store';
import { isPlatformServer } from '@angular/common';
import { PRODUCTS_CATALOG_BLOK } from '~shared/constants';
import { getStoryblokSeoContent, isStoryblokSeoLoading } from '~shared/modules/storyblok-seo/store';
import { StoryblokApiResponse } from '~app/modules/storyblok/models/storyblok-api-response.model';
import { StoryblokComponent, StoryData } from 'storyblok-js-client';
import { Components } from '~app/modules/storyblok/constants';
import { InputsType } from 'ng-dynamic-component';

@Component({
  selector: 'app-category-plp',
  templateUrl: './category-plp.component.html',
  styleUrls: ['./category-plp.component.scss'],
})
export class CategoryPlpComponent {
  @Input() commonProps = {} as CommonProps;

  protected readonly components = Components;
  selectedCategory$: Observable<Category>;
  isSeoContentLoading$: Observable<boolean>;
  isServer: boolean = isPlatformServer(this.platformId);
  story: StoryData;
  storyEditable: string;
  storyblokContent: Array<StoryblokComponent<string>>;
  hidePageTitle: boolean = false;

  private unsubscribe$ = new Subject();
  private storyId: number;

  constructor(private store$: Store<CatalogState>, @Inject(PLATFORM_ID) private platformId: Object) {
    this.checkContentOnStoryblokEdit();
  }

  ngOnInit(): void {
    this.isSeoContentLoading$ = this.store$.pipe(select(isStoryblokSeoLoading), takeUntil(this.unsubscribe$));
    this.initializeSeoContent();
    this.initializeSelectedCategory();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private initializeSelectedCategory(): void {
    this.selectedCategory$ = this.store$.pipe(select(getCategory), takeUntil(this.unsubscribe$));
  }

  buildInputs(blokInputs: InputsType): InputsType {
    if (blokInputs.component === PRODUCTS_CATALOG_BLOK) {
      return {
        ...blokInputs,
        ...{
          categoryProps: this.commonProps,
          hidePageTitle: this.hidePageTitle,
          isMobile: this.commonProps.isMobile,
          isTablet: this.commonProps.isTablet,
          isDesktop: this.commonProps.isDesktop,
          isLandScapeTablet: this.commonProps.isLandScapeTablet,
        },
      };
    }

    return {
      ...blokInputs,
      ...{
        isMobile: this.commonProps.isMobile,
        isTablet: this.commonProps.isTablet,
        isDesktop: this.commonProps.isDesktop,
        isLandScapeTablet: this.commonProps.isLandScapeTablet,
      },
    };
  }

  private initializeSeoContent(): void {
    this.store$
      .pipe(select(getStoryblokSeoContent), takeUntil(this.unsubscribe$))
      .subscribe((response: StoryblokApiResponse) => {
        if (!response) {
          this.cleanStory();
          return;
        }
        this.story = response.story;
        this.storyId = response.story.id;
        this.storyEditable = response.story.content._editable;
        this.hidePageTitle = response.story.content.hide_page_title;
        this.applyStoryblokStoryData(this.story);
      });
  }

  private cleanStory(): void {
    this.story = undefined;
    this.storyId = undefined;
    this.storyEditable = undefined;
    this.hidePageTitle = false;
  }

  private checkContentOnStoryblokEdit(): void {
    window?.storyblok?.on('input', (event: StoryblokEventPayload) => {
      window?.storyblok.addComments(event.story.content, String(event.story.id));
      if (event.story.id === this.storyId) {
        this.applyStoryblokStoryData(event.story);
      }
    });
  }

  private applyStoryblokStoryData(story: StoryData): void {
    this.storyblokContent = story.content.body || [];
  }
}
